/**
 * DATA LAYER (DL): ATTENDANCE (Registro de Asistencia)
 */

export const GetConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Attendance/config`);
        if (!response.ok) throw new Error('Error al obtener la configuración de asistencia');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const SaveConfig = async (data) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Attendance/save-config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Error al guardar la configuración de asistencia');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const RegisterAttendance = async (subscriberCode) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Attendance/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ subscriberCode })
        });
        if (!response.ok) throw new Error('Error al registrar asistencia');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const GetRecords = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Attendance/records`);
        if (!response.ok) throw new Error('Error al obtener el historial de registros');
        return await response.json();
    } catch (error) {
        return [];
    }
};

export const DeleteRecord = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Attendance/records/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error('Error al eliminar registro');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const UploadMedia = async (file, type) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        if (type) formData.append('type', type);

        const response = await fetch(`${process.env.REACT_APP_API_URL}Attendance/UploadMedia`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error('Error al subir archivo');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};
